import React from 'react';
import PropTypes from 'prop-types';
import { Image as SashImage } from '@pella/sash-framework';

const Image = ({ data, className, ...other }) => {
	if (!data) return null;

	return (
		<SashImage
			src={data.file?.gatsbyImageData?.images?.fallback?.src || data.file?.url}
			srcSet={data.file?.gatsbyImageData?.images?.fallback?.srcSet}
			sizes={data.file?.gatsbyImageData?.images?.fallback?.sizes}
			width={data.file?.gatsbyImageData?.width}
			height={data.file?.gatsbyImageData?.height}
			objectFit={data.contain ? 'contain' : 'cover'}
			className={className || ''}
			alt={data.alt_text || ''}
			{...other}
		/>
	);
};

Image.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default Image;
